/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const LocksEnum = {
    GET_LOCK_STATUS: '/locks',
    DELETE_LOCK_USER: '/locks/user'
};
